import React, { Key, memo } from 'react';
import { Checkbox, styled } from '@material-ui/core';
import NkCell from './../nkCell';
import { Columns, DataItem } from '../nkCustomTable.types';

interface NkRowProps {
  item: DataItem;
  columns: Columns;
  rowIndex: Key;
  isSelected: boolean;
  showSelection: boolean;
  onSelectRow: (
    rowIndex: Key,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const NkRow = ({
  columns,
  item,
  rowIndex,
  isSelected,
  onSelectRow,
  showSelection,
}: NkRowProps) => {
  return (
    <StyledTr>
      {showSelection && <StyledCheckboxTd>
        <Checkbox
          checked={isSelected}
          onChange={onSelectRow(rowIndex)}
          color="primary"
        />
      </StyledCheckboxTd>}
      {columns.map((column) => {
        if (column.isHide) {
          return null;
        }

        return <NkCell key={column.key} column={column} data={item}/>
        })
      }
    </StyledTr>
  );
};

export default memo(NkRow);

const StyledTr = styled('tr')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const StyledCheckboxTd = styled('td')({
  width: 60,
  textAlign: 'center',
});
